<div class="help-dialog">
    <sync-dialog [config]="{
        title: 'Get help',
        isClosable: true,
      }" [isFullScreen]="false" [open]="openHelpDialog" [onClose]="closeHelpDialog">
        <div class="help-link-dialog-container">
            <p>Having trouble signing in? Check out our help center for step‑by‑step troubleshooting.</p>
            <sync-list [ListItems]="helpCategories"></sync-list>
        </div>
    </sync-dialog>
</div>